/**

 Copyright (c) 2018, MOBICOOP. All rights reserved.
 This project is dual licensed under AGPL and proprietary licence.

 This program is free software: you can redistribute it and/or modify
 it under the terms of the GNU Affero General Public License as
 published by the Free Software Foundation, either version 3 of the
 License, or (at your option) any later version.
 This program is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 GNU Affero General Public License for more details.
 You should have received a copy of the GNU Affero General Public License
 along with this program. If not, see gnu.org/licenses.

 Licence MOBICOOP described in the file
 LICENSE
 **************************/

import http from '../Mixin/http.mixin'
import { isPlatform } from "@ionic/core";

export const registerStore = {
  state: {
    statusRegister: '',
    statusValidateToken: '',
    statusCheckEmail: '',
    statusCheckPhoneNumberValidity: '',
    displayAddress: '',
    addresses: [],
    userToRegister: null,
    checkEmailErrorMessage: null,
  },
  mutations: {
    register_request(state) {
      state.statusRegister = 'loading';
    },

    register_success(state) {
      state.statusRegister = 'success';
    },

    register_error(state) {
      state.statusRegister = 'error';
    },

    validate_token_request(state) {
      state.statusValidateToken = 'loading';
    },

    validate_token_success(state) {
      state.statusValidateToken = 'success';
    },

    validate_token_error(state) {
      state.statusValidateToken = 'error';
    },

    check_email_request(state) {
      state.statusCheckEmail = 'loading';
    },

    check_email_success(state, err) {
      state.checkEmailErrorMessage = null
      state.statusCheckEmail = 'success';
    },

    check_email_error(state, err) {
      if (err) {
        state.checkEmailErrorMessage = err;
      }
      state.statusCheckEmail = 'error';
    },

    check_phone_number_validity_request(state) {
      state.statusCheckPhoneNumberValidity = 'loading';
    },

    check_phone_number_validity_success(state, err) {
      state.checkPhoneNumberValidityMessage = null
      state.statusCheckPhoneNumberValidity = 'success';
    },

    check_phone_number_validity_error(state, err) {
      if (err) {
        state.checkPhoneNumberValidityMessage = err;
      }
      state.statusCheckPhoneNumberValidity = 'error';
    },

    register_update(state, value) {
      state.userToRegister = value;
    },

    changeRegisterAddress(state, payload) {
      payload.addressDTO.home = true;
      state.userToRegister.addresses = [payload.addressDTO];
      state.displayAddress = payload.displayGeo;
    },

    register_reset(state) {
      let n = new Date();
      n.setFullYear(n.getFullYear() - 18);

      state.userToRegister = {
        status: 1,
        givenName: '',
        familyName: '',
        gender: '',
        telephone: '',
        email: '',
        password: '',
        confirmPassword: '',
        communityId: null,
        multiTransportMode: true,
        userAgreementAccepted: false,
        phoneDisplay: 1,
        birthDate: JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE) ? n.toISOString() : null,
        maxDeviationTime: 600,
        maxDeviationDistance: 10000,
        anyRouteAsPassenger: false,
        newsSubscription: false,
        hitchHikeDriver: false,
        hitchHikePassenger: false,
        mobileRegistration: 1,
        language: "fr_FR",
        addresses: '',
        postalAddress: ''
      };
      state.displayAddress = '';
    }

  },
  actions: {
    // Register
    register: ({ commit, state }) => {
      commit('register_request');
      const u = Object.assign({}, state.userToRegister);
      delete u.registerFromMobile;
      delete u.confirmPassword;
      delete u.addresses[0].id;
      delete u.addresses[0].geoJson;
      delete u.language;
      u.mobileRegistration = 1;
      u.communityId = u.communityId && u.communityId.length > 0 ? u.communityId[0] : null
      if (isPlatform(window.document.defaultView, "ios")) {
        u.mobileRegistration = 2;
      }
      if (isPlatform(window.document.defaultView, "android")) {
        u.mobileRegistration = 3;
      }
      u.backLink = process.env.VUE_APP_DOMAIN + '/#/confirm-registration/' + u.email + '?token=';

      /*
      if (u.communityId) {
        u.communityId = Number(u.communityId)
      }
       */
      if (!u.gender) {
        u.gender = 0
      }

      return new Promise((resolve, reject) => {
        http.post("/users/register", u).then(resp => {
          if (resp) {
            commit('register_success');
            resolve(resp)
          }
        }).catch(err => {
          commit('register_error');
          reject(err)
        })
      })
    },
    validateToken: ({ commit, state }, params) => {
      commit('validate_token_request');
      let mobile = '';
      if (isPlatform(window.document.defaultView, "ios")) {
        mobile = '?mobile=1'
      }
      if (isPlatform(window.document.defaultView, "android")) {
        mobile = '?mobile=2'
      }

      return new Promise((resolve, reject) => {
        http.post("/login-token" + mobile, params).then(resp => {
          if (resp && resp.data && resp.data.token) {
            const tokenUser = resp.data.token;
            localStorage.setItem('tokenUser', tokenUser);
            commit('auth_success', tokenUser);

            commit('validate_token_success');
            resolve(resp)
          } else {
            commit('validate_token_error');
            reject(resp.data)
          }
        }).catch(err => {
          commit('validate_token_error');
          reject(err)
        })
      })
    },
    checkEmail: ({ commit, state }, params) => {
      commit('check_email_request');
      return new Promise((resolve, reject) => {
        http.get("/users/checkEmail?email=" + params).then(resp => {
          if (resp.data && resp.data.error) {
            commit('check_email_error', resp.data.message);
            reject(false)
          } else {
            commit('check_email_success');
            resolve(true)
          }
        }).catch(err => {
          commit('check_email_error', err.response.data["hydra:description"]);
          reject(false)
        })
      })
    },
    checkPhoneNumberValidity: ({ commit, state }, params) => {
      commit('check_phone_number_validity_request');

      let phoneValidation = {
        phoneNumber: params
      }

      return new Promise((resolve, reject) => {
        http.post("/phone_validations",phoneValidation).then(resp => {
          if (resp.data && !resp.data.valid) {
            commit('check_phone_number_validity_error', resp.data.message);
            reject(false)
          } else {
            commit('check_phone_number_validity_success');
            resolve(true)
          }
        }).catch(err => {
          commit('check_phone_number_validity_error', err.response.data["hydra:description"]);
          reject(false)
        })
      })
    },

    getUserUnderEighteen: ({ commit, state }, code) => {
      return new Promise((resolve, reject) => {
        http.get('/user_under_eighteens/999999/token?token=' + code ).then(resp => {
          if (resp) {
            resolve(resp)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },

    postUserUnderEighteen: ({ commit, state }, params) => {
      return new Promise((resolve, reject) => {
        http.post('/user_under_eighteens/giveParentalConsent', params ).then(resp => {
          if (resp) {
            resolve(resp)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  getters: {

  }
}

export default { registerStore };
